export enum AlertEvaluationPeriod {
  ThreeMonths,
  SixMonths,
  TwelveMonths,
  YearToDate,
  Custom
}
